export default __webpack_public_path__ + "static/media/vdo.e29b11f6.mp4";